import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance } from './Instant.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SystemClass;
function System() {
  if (SystemClass === VOID) {
    class $ {
      b1m() {
        return Companion_getInstance().b1m();
      }
    }
    initMetadataForObject($, 'System');
    SystemClass = $;
  }
  return SystemClass;
}
var System_instance;
function System_getInstance() {
  return System_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
//region block: init
System_instance = new (System())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance1i4n4o7mef2za,
  System_instance as System_instance3dr57gee6r420,
};
//endregion

//# sourceMappingURL=Clock.mjs.map
